/**
 * Calculator Frontend entry point.
 *
 * src/front/front.js
 */
import {
	insertUrlParam,
	removeUrlParameter,
} from "./utils/urlParamHandlers.js";
import fireSuccessSwal from "./utils/swalManager.js";
import videoPlayHook from "./utils/videoPlayHook.js";

import cSPrefillCalculatorResultsPosting from "./utils/cSPrefillCalculatorResultsPosting.js";
import cSRenderCalculatorResults from "./utils/cSRenderCalculatorResults.js";
import cSPrefillCalculatorResultsContent from "./utils/cSPrefillCalculatorResultsContent.js";
import cSPrefillCalculatorResults from "./utils/cSPrefillCalculatorResults.js";

import OnboardingFlow from "./utils/OnboardingFlow.js";
import MyGamePlanActionFlow from "./my-game-plan/MyGamePlanActionFlow.js";
import MediaKitCompleteFlow from "./utils/MediaKitCompleteFlow.js";
import MyGamePlanLevelTooltips from "./my-game-plan/MyGamePlanLevelTooltips.js";
import downloadMediaKitPDF from "./utils/downloadMediaKitPDF.js";

import * as constants from "./constants";
import SocialMetricsHelper from "./utils/SocialMetricsHelper.js";
import DateRangePickers from "./utils/DateRangePickers.js";

for (const key in constants) {
	if (Object.hasOwn(constants, key)) {
		window[key] = constants[key];
	}
}

const dateRangePickers = new DateRangePickers();
const csUpdateDateRangePickers = function(start, end, callback) {
	dateRangePickers.updateDateRange(start, end, callback);
}

window.csUpdateDateRangePickers = csUpdateDateRangePickers;
window.cSPrefillCalculatorResultsPosting = cSPrefillCalculatorResultsPosting;
window.cSRenderCalculatorResults = cSRenderCalculatorResults;
window.cSPrefillCalculatorResultsContent = cSPrefillCalculatorResultsContent;
window.cSPrefillCalculatorResults = cSPrefillCalculatorResults;
window.insertUrlParam = insertUrlParam;
window.removeUrlParameter = removeUrlParameter;
window.fireSuccessSwal = fireSuccessSwal;

const onboardingFlowControl = new OnboardingFlow();
const myGamePlanActions = new MyGamePlanActionFlow(onboardingFlowControl);
const mediaKitFlow = new MediaKitCompleteFlow(myGamePlanActions);
const socialMetricsHelper = new SocialMetricsHelper;
const myGamePlanLevelTooltips = new MyGamePlanLevelTooltips();


// this function will be used by the shortcode inside the page for the video How to Price yourself with confidence, when the video reaches 65 percent of the duration, it will unlock the items.
const videoUnlockHowToPriceSelf = () => {
	// if (parseInt(CSWP.how_to_price_self_unlocked) == 1) {
	// 	return;
	// }
	videoPlayHook(() => {
		onboardingFlowControl.unlockHowtoPriceSelf();
	});
}

window.videoUnlockHowToPriceSelf = videoUnlockHowToPriceSelf;
window.downloadMediaKitPDF = downloadMediaKitPDF;

document.addEventListener("DOMContentLoaded", function (event) {
	dateRangePickers.bindEvents();
	onboardingFlowControl.bindEvents();
	myGamePlanActions.bindEvents();
	mediaKitFlow.init();
	socialMetricsHelper.bindEvents();
	myGamePlanLevelTooltips.bindEvents();
});
